import React from 'react';
import PropTypes from 'prop-types';
import UserCard from '../UserCard';
import './styles.scss';
import UserLogo from './../../icons/users.svg';
import LoadingComponent from '../LoadingComponent';

function UserList({
    users,
    onRemoveUser,
    onCancelInvite,
    showDeleteButton,
    userId,
    componentType,
    isLoading,
}) {
    const list =
        users &&
        users.map(
            ({ id, fullName, profilePicture, isCreator, email, status }) => {
                return (
                    <UserCard
                        name={fullName}
                        profilePicture={profilePicture}
                        id={id}
                        userId={userId}
                        key={id || email}
                        status={status}
                        email={email}
                        isLoading={isLoading}
                        onRemoveUser={(id) => onRemoveUser(id)}
                        onCancelInvite={(email) => onCancelInvite(email)}
                        showDeleteButton={
                            showDeleteButton &&
                            (!isCreator ||
                                componentType == 'Citizen Science Researchers')
                                ? true
                                : false
                        }
                    />
                );
            },
        );
    const loader = (
        <div className="buttonLoader">
            <LoadingComponent isLoading={true} />
        </div>
    );
    return (
        <>
            {users && users.length ? (
                <>
                    <ul className="row user-list-padding">{list}</ul>
                    {isLoading ? loader : null}
                </>
            ) : (
                <ul className="row justify-content-center no-user-margin">
                    <div className="col-lg-2 col-md-3 col-xs-4">
                        <div className="row justify-content-center">
                            <div className="col-10 no-user-image">
                                <img src={UserLogo} />
                            </div>
                        </div>

                        <div className="row justify-content-center">
                            <p className="no_user">No User Added</p>
                        </div>
                    </div>
                </ul>
            )}
        </>
    );
}

UserList.propTypes = {
    // user array to be displayed inside list
    users: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.number,
            fullName: PropTypes.string,
            profilePicture: PropTypes.string,
            isCreator: PropTypes.bool,
        }),
    ),
    onRemoveUser: PropTypes.func,
    onCancelInvite: PropTypes.func,
    showDeleteButton: PropTypes.bool,
    userId: PropTypes.number,
    componentType: PropTypes.string,
    isLoading: PropTypes.bool,
};

UserList.defaultProps = {
    users: [],
    showDeleteButton: false,
    userId: null,
    componentType: null,
};

export default UserList;
